export const EmailMask = (email) => {
    if (email) {
        // Trim whitespace and split the email into local and domain parts
        const [local, domain] = email.trim().split('@');

        // Mask the local part, keeping the first character and every fourth character
        const maskedLocal = local.split('').map((char, index) =>
            index === 0 || index % 4 === 0 ? char : '*'
        ).join('');

        // Return the masked email
        return `${maskedLocal}@${domain}`;

    }
}